import BussinesIcon from '../../assets/images/customSideBar/BussinesIcon';
import BussinesIconDisabled from '../../assets/images/customSideBar/BussinesIconDisabled';
import Catalogue from '../../assets/images/customSideBar/Catalogue';
import Configuration from '../../assets/images/customSideBar/Configuration';
import CountriesIcon from '../../assets/images/customSideBar/CountriesIcon';
import OrdersListIcon from '../../assets/images/customSideBar/OrdersListIcon';
import PaymentRequest from '../../assets/images/customSideBar/PaymentRequest';
import Pills from '../../assets/images/customSideBar/Pills';
import Smile from '../../assets/images/customSideBar/Smile';
import Star from '../../assets/images/customSideBar/Star';
import TruckIcon from '../../assets/images/customSideBar/TruckIcon';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import MegaPhoneIcon from '../../assets/images/customSideBar/MegaPhoneIcon';
import { BACKOFFICE_MODULES } from 'types/configuration.types';
import { bordColorTheme } from 'styles/styles.constants';

export const getSidebarModules = (selectedModule: string, onlyDevelopers?: boolean) => [
  {
    img: (
      <BordOneToneIcon
        variant="home"
        stroke={selectedModule === 'dashboard' ? 'white' : '#070F21'}
        customWidth={'18px'}
      />
    ),
    name: 'dashboard',
    title: 'Home',
    route: '/dashboard',
    show: true
  },
  {
    img:
      selectedModule === 'organization' ? (
        <BussinesIcon className="organizationIcon" />
      ) : (
        <BussinesIconDisabled className="organizationIcon" />
      ),
    name: 'organization',
    title: 'Empresas',
    route: '/organization/list',
    show: true
  },
  {
    img: <Catalogue className="catalogIcon" stroke={selectedModule === 'catalog' ? 'white' : '#070F21'} />,
    name: 'catalog',
    title: 'Catálogo',
    route: '/catalog/product-list',
    show: true
  },
  {
    img:
      selectedModule === 'country' ? (
        <CountriesIcon className="countriesIcon active " />
      ) : (
        <CountriesIcon className="countriesIcon " />
      ),
    name: 'country',
    title: 'Países',
    route: '/country/listing',
    show: true
  },
  {
    img:
      selectedModule === 'order' ? (
        <OrdersListIcon className="orderIcon" stroke="white" />
      ) : (
        <OrdersListIcon className="orderIcon" stroke="#070F21" />
      ),
    name: 'order',
    title: 'Órdenes',
    route: '/order/shopping',
    show: true
  },
  {
    img: (
      <OrdersListIcon
        className="orderIcon"
        stroke={
          selectedModule === BACKOFFICE_MODULES.TRACKING_ORDER
            ? bordColorTheme.white.default
            : bordColorTheme.navyBlue[900]
        }
      />
    ),
    name: 'trackingOrder',
    title: 'Tracking Order',
    route: '/tracking-order/main',
    show: onlyDevelopers
  },
  {
    img: (
      <BordOneToneIcon
        variant="shop"
        stroke={selectedModule === 'stock' ? 'white' : '#070F21'}
        customWidth="18px"
        className="stockOrderIcon"
      />
    ),
    name: 'stock',
    title: 'Órdenes stock',
    route: '/stock/list-stock',
    show: true
  },
  {
    img:
      selectedModule === 'logisticService' ? (
        <TruckIcon className="logisticServiceIcon" stroke="white" />
      ) : (
        <TruckIcon className="logisticServiceIcon" />
      ),
    name: 'logisticService',
    title: 'Servicios logs.',
    route: '/logistic-service/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="billing"
        stroke={selectedModule === 'billing' ? 'white' : '#070F21'}
        customWidth={'18px'}
      />
    ),
    name: 'billing',
    title: 'Facturación',
    route: '/billing/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="monitor"
        stroke={selectedModule === 'tools' ? 'white' : '#070F21'}
        customWidth={'18px'}
      />
    ),
    name: 'tools',
    title: 'Herramientas',
    route: '/tools/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="download"
        customWidth={'18px'}
        stroke={selectedModule === 'bulkUpload' ? 'white' : '#070F21'}
      />
    ),
    name: 'bulkUpload',
    title: 'Cargue Masivo',
    route: '/bulk-upload/type-of-charge',
    show: true
  },
  {
    img:
      selectedModule === 'paymentRequest' ? (
        <PaymentRequest stroke="white" fill="#070F21" />
      ) : (
        <PaymentRequest stroke="#070F21" />
      ),
    name: 'paymentRequest',
    title: 'Solicitar Pagos',
    route: '',
    externalRoute: 'https://finance.bord.co/',
    show: true
  },
  {
    img:
      selectedModule === 'brand' ? (
        <Star className="brandIcon" fill="#070F21" stroke="white" />
      ) : (
        <Star className="brandIcon" />
      ),
    name: 'brand',
    title: 'Marcas',
    route: '/brand/list',
    show: true
  },
  {
    img:
      selectedModule === 'category' ? (
        <Pills className="categoryIcon" />
      ) : (
        <Pills className="categoryIcon" fill="white" stroke="#070F21" />
      ),
    name: 'category',
    title: 'Categorías',
    route: '/category/modify-pills',
    show: onlyDevelopers
  },
  {
    img:
      selectedModule === 'configuration' ? (
        <Configuration className="configurationIcon" stroke="white" fill="#070F21" />
      ) : (
        <Configuration className="configurationIcon" stroke="#070F21" />
      ),
    name: 'configuration',
    title: 'Configuración',
    route: '/configuration/details',
    show: true
  },
  {
    img: <Smile className="homeIcon" fill={selectedModule === 'opsSupport' ? 'white' : ''} />,
    name: 'opsSupport',
    title: 'Soporte',
    route: '/ops-support/start',
    show: onlyDevelopers
  },
  {
    img:
      selectedModule === 'announcement' ? (
        <MegaPhoneIcon className="megaPhoneIcon" stroke="white" />
      ) : (
        <MegaPhoneIcon className="megaPhoneIcon" stroke="#070F21" fill="white" />
      ),
    name: 'announcement',
    title: 'Anuncios',
    route: '/announcement',
    show: true
  },
  {
    img: <Smile className="homeIcon" fill={selectedModule === 'home' ? 'white' : ''} />,
    name: 'home',
    show: false
  }
];

export interface IsidebarModule {
  img: JSX.Element;
  name: string;
  title?: string;
  route?: string;
  show?: boolean;
  externalRoute?: string;
}
